import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientToken } from "../../../tokens";
import type {
    RewardsReferralProgramEntity,
    RewardsReferralsResponseType,
} from "../models/RewardsReferralProgramEntities";
import {
    RewardsReferralProgramSchema,
    RewardsReferralsResponseSchema,
} from "../models/RewardsReferralProgramSchemas";
import type { RewardsReferralsQueryParams } from "../types";

@singleton()
class RewardsReferralProgramApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    getReferralProgramReward(): Observable<RewardsReferralProgramEntity> {
        return this.apiClient
            .get({
                url: "/referral/getPrizeList",
                responseType: "json",
            })
            .pipe(
                map((value) => create(value.body, RewardsReferralProgramSchema))
            );
    }

    getReferredCustomerList(
        queryParams: RewardsReferralsQueryParams
    ): Observable<RewardsReferralsResponseType> {
        return this.apiClient
            .get({
                url: "/referral/getReferredCustomerList",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((value) =>
                    create(value.body, RewardsReferralsResponseSchema)
                )
            );
    }
}

export default RewardsReferralProgramApiService;
